(() => {
  if (window.PagModalGate) return;
  const P = 'pag-modal:';
  const store = (area) => ({
    get: (k) => { try { return area.getItem(P + k); } catch { return null; } },
    set: (k, v) => { try { area.setItem(P + k, v); } catch {} },
  });
  const ls = store(localStorage);
  const ss = store(sessionStorage);
  const DAY = 864e5;

  ss.set('views', String((Number(ss.get('views')) || 0) + 1));
  if (/[?&]customer_posted=true/.test(location.search)) ls.set('done:newsletter', '1');

  const age = (k) => (Date.now() - (Number(ls.get(k)) || 0)) / DAY;

  window.PagModalGate = {
    forced: /[?&]pagmodal=1/.test(location.search),

    eligible(id, c) {
      if (this.forced) return true;
      if (ls.get('done:' + id) || (c.newsletter && ls.get('done:newsletter'))) return false;
      if (ss.get('shown')) return false;
      if ((Number(ss.get('views')) || 0) < c.minViews) return false;
      if (age('dismissed:' + id) < c.cooldownDays) return false;
      if (age('last-shown') < c.globalGapDays) return false;
      return (Number(ls.get('count:' + id)) || 0) < c.maxShows;
    },

    // Fires `show` once after the delay or the scroll depth, whichever comes first.
    schedule(c, show) {
      let fired = false;
      const fire = () => {
        if (fired) return;
        const busy = document.querySelector('dialog[open]') || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '');
        if (busy) return void setTimeout(fire, 4000);
        fired = true;
        cleanup();
        show();
      };
      const onScroll = () => {
        const max = document.documentElement.scrollHeight - innerHeight;
        if (max > 0 && scrollY / max >= c.scrollPct / 100) fire();
      };
      const timer = setTimeout(fire, this.forced ? 300 : c.delay * 1000);
      const cleanup = () => { clearTimeout(timer); removeEventListener('scroll', onScroll); };
      if (!this.forced && c.scrollPct > 0) addEventListener('scroll', onScroll, { passive: true });
    },

    shown(id) {
      ss.set('shown', '1');
      ls.set('last-shown', String(Date.now()));
      ls.set('count:' + id, String((Number(ls.get('count:' + id)) || 0) + 1));
    },
    dismissed(id) { ls.set('dismissed:' + id, String(Date.now())); },
    done(id) { ls.set('done:' + id, '1'); },
  };
})();
